import React from "react"

import Link from "../../utils/link"
import Img from "gatsby-image"


const HotelSectionContentOne = (props) => {
  return (
    <>
      <div className="hotel-section__container__image">
        <Img
          fluid={props.image.localFile.childImageSharp.fluid}
          alt={props.image.altText}
        />
      </div>
      <div className="hotel-section__container__text">
        <div className="hotel-section__container__text__heading">
          {props.title}
        </div>
        <div className="hotel-section__container__text__sub-text">
          {props.subtitle}
        </div>
        <div className="hotel-section__container__text__paragraph">
          {props.content}
        </div>
        <div className="hotel-section__container__text__order">
          <Link
            to={props.button.link}
            className="hotel-section__container__text__order__book-table"
          >
            {props.button.text}
          </Link>
          <Link
            to={props.contact.link}
            className="hotel-section__container__text__order__contact"
          >
            {props.contact.text}
          </Link>
        </div>
      </div>
    </>
  )
}

export default HotelSectionContentOne
